(function () {
    'use strict';

    angular.module('eDocumentsApp').factory('IntegrityWarningService', IntegrityWarningService);

    IntegrityWarningService.$inject = ['$uibModal', '$q'];

    function IntegrityWarningService($uibModal, $q) {
        var service = {
            checkAndWarn: checkAndWarn,
            hasIntegrityIssues: hasIntegrityIssues,
            getFailedFiles: getFailedFiles
        };

        return service;

        /**
         * Checks if any files have integrity issues and shows a warning dialog if needed.
         * Returns a promise that resolves if the user proceeds or if there are no issues,
         * and rejects if the user cancels.
         *
         * @param files Array of file objects with checksumValid property
         * @param onProceed Callback function to execute when user acknowledges and proceeds
         * @returns Promise
         */
        function checkAndWarn(files, onProceed) {
            var deferred = $q.defer();

            if (!hasIntegrityIssues(files)) {
                // No issues, proceed immediately
                deferred.resolve();
                return deferred.promise;
            }

            var failedFiles = getFailedFiles(files);

            $uibModal.open({
                templateUrl: 'app/components/integrity-warning/integrity-warning.dialog.html',
                controller: 'IntegrityWarningDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    failedFiles: function () {
                        return failedFiles;
                    },
                    onProceed: function () {
                        return onProceed;
                    }
                }
            }).result.then(
                function (result) {
                    // User acknowledged and proceeded
                    deferred.resolve(result);
                },
                function () {
                    // User cancelled
                    deferred.reject('cancelled');
                }
            );

            return deferred.promise;
        }

        /**
         * Checks if any files in the array have integrity issues.
         *
         * @param files Array of file objects with checksumValid property
         * @returns Boolean
         */
        function hasIntegrityIssues(files) {
            if (!files || !Array.isArray(files)) {
                return false;
            }
            return files.some(function (file) {
                return file.checksumValid === false;
            });
        }

        /**
         * Gets the list of files that failed integrity validation.
         *
         * @param files Array of file objects with checksumValid property
         * @returns Array of failed files
         */
        function getFailedFiles(files) {
            if (!files || !Array.isArray(files)) {
                return [];
            }
            return files.filter(function (file) {
                return file.checksumValid === false;
            });
        }
    }
})();
